import React from "react";
// import Spring from "../images/spring.jpg";
import Summer from "../images/summer.jpg";
import Fall from "../images/fall.jpg";
// import Winter from "../images/winter.jpg";

export default function Season() {
  return (
    <section className="seasonContainer" id="season">
      <div>
        <img src={Summer} alt="season" className="seasonImg" />
        <span className="seasonContainerHeader">Sensommer sæson 2026</span>
        <p>Uge 33-41 (lukket i uge 42)</p>
        <p>9 ugers træning til 1237,50 kr incl. moms.</p>
        <p>Under 30 år: 990 kr.</p>
      </div>
      <div>
        <img src={Fall} alt="season" className="seasonImg" />
        <span className="seasonContainerHeader">Efterårs sæson 2026</span>
        <p>Uge 43-51</p>
        <p>9 ugers træning til 1237,50 kr incl. moms.</p>
        <p>Under 30 år: 990 kr.</p>
      </div>
    </section>
  );
}
